<div class="like-container">
  <span class="material-icons like-span" [class.like-red]="_isLiked" (click)="toggleLike()">
    {{ _isLiked ? 'favorite' : 'favorite_border' }}
  </span>
  @if (_showCount) {
    <div class="like-count">{{ _count }}</div>
  }
</div>
